module.exports = __webpack_public_path__ + "img/ocbc-notification.5ceceb77.svg";